/**
 * Summary Utilities
 * 
 * This module provides utility functions for generating summary prompts
 * from CRM data objects like notes, accounts, and contacts.
 * 
 * Key features:
 * - Generates formatted prompts for AI summarization
 * - Formats note data with proper date display, handling both Date objects and ISO strings
 * - Includes related entity information (account, contact, author)
 * - Returns structured prompts for table display and next step suggestions
 */

import { Note } from '../models/Note';

export function getNotesSummaryPrompt(notes: Note[]): string {

  if (!notes || notes.length === 0) return 'No notes to summarize';

  const noteText = (note: Note) => {
    const date = note.updatedAt instanceof Date ? note.updatedAt : new Date(note.updatedAt);
    const noteData = {
      id: note.id,
      title: note.title,
      content: note.content,
      author: note.author || null,
      accountName: note.accountName || null,
      contactName: note.contactName || null,
      date: date.toLocaleString()
    };
    return JSON.stringify(noteData, null, 2);
  }
  const prompt = `- Summarize the CRM notes below, Add suggest next steps, what can be done with these notes. e.g., summarize, generate analysis report, generate to-do list, identify issues, etc. based on the notes. Be creative.
  
  \n\n
  ${notes.map(n => noteText(n)).join('\n\n')}`;
  return prompt;
}
